import React, { Component } from 'react'
import ListItemText from '@material-ui/core/ListItemText'
import { injectIntl } from 'react-intl'
import ArrowIcon from '@material-ui/icons/ExpandMore'
import { Collapse } from '@material-ui/core'
import cn from 'classnames'
import isEmpty from 'lodash.isempty'
import {
  ifLogbookConstant,
  TYPE_INPUT_BOOLEAN,
  TYPE_INPUT_FILE,
  TYPE_INPUT_TEXTAREA,
  TYPE_LIST,
} from 'helpers/logbook'
import EventField from './EventFields'

class MasterEventField extends Component {
  constructor(props) {
    super(props)

    this.state = {
      masterEventValue: '',
      masterEvent: {},
    }
  }

  componentDidMount() {
    const {
      eventInfo: { slaves },
    } = this.props
    const hasSlaveEvents = this.isNotEmptyArray(slaves)

    if (hasSlaveEvents) {
      this.getInitialMasterEvent()
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { eventInfo } = this.props
    const { masterEventValue } = this.state
    const { eventInfo: newEventInfo } = nextProps
    const { masterEvent: newMasterEvent } = nextState
    const hasSlaveEvents = this.isNotEmptyArray(eventInfo.slaves)
    const value = masterEventValue || newMasterEvent.value

    if (hasSlaveEvents && eventInfo.values !== newEventInfo.values) {
      const masterEvent = this.getDataFromList(
        newEventInfo.values,
        this.getValueTypeByEventField(value),
      )

      if (isEmpty(masterEvent)) {
        this.getInitialMasterEvent(newEventInfo.values)
      } else {
        this.setState({
          masterEvent,
        })
      }

      return false
    }

    return true
  }

  getDataFromList = (data, value) => {
    if (!this.isNotEmptyArray(data) || !value) {
      return {}
    }

    return data.reduce((accu, el) => (el.value === value ? el : accu), {})
  }

  getInitialMasterEvent = data => {
    const {
      eventInfo: { values },
    } = this.props
    const currentData = data || values
    let masterEvent =
      this.isNotEmptyArray(currentData) &&
      (currentData.length > 1
        ? currentData[currentData.length - 1]
        : currentData[0])

    if (isEmpty(masterEvent)) {
      masterEvent = {}
    }

    this.setState({
      masterEvent,
    })
  }

  onMasterEventValueChange = data => {
    const { masterEvent } = this.state
    const { onEventValueChange, showAllSlaveEvents } = this.props
    const { value } = data
    let newMasterEvent = {}

    if (masterEvent.value !== value) {
      newMasterEvent = this.findMasterEvent(value)

      showAllSlaveEvents()
    }

    /* eslint-disable no-param-reassign */
    data.master = true
    data.masterEvent = true
    data.masterEventIsNew = isEmpty(newMasterEvent)

    this.setState(
      {
        masterEventValue: value,
      },
      () => {
        onEventValueChange(data)
      },
    )
  }

  onSlaveEventValueChange = (data, slaveEvent) => {
    const { onEventValueChange } = this.props
    const { masterEvent } = this.state

    if (slaveEvent && slaveEvent.evt_id) {
      data.evt_logbook_id = slaveEvent.evt_id
    } else {
      data.parentEvtLogbook = masterEvent.evt_id
    }
    /* eslint-enable no-param-reassign */

    const { id: slave_id, evt_logbook_id: evt_id, value } = data
    const slave = masterEvent.slaves.find(
      item => item.evt_id === evt_id && item.slave_id === slave_id,
    )

    if (slave) {
      slave.value = value
    } else {
      masterEvent.slaves.push({ evt_id, slave_id, value })
    }

    this.setState(
      {
        masterEvent: { ...masterEvent },
      },
      () => {
        onEventValueChange(data)
      },
    )
  }

  findMasterEvent = masterValue => {
    const { masterEvent } = this.state
    const {
      eventInfo: { values },
    } = this.props
    const value = masterValue || masterEvent.value
    const newMasterEvent = this.getDataFromList(
      values,
      this.getValueTypeByEventField(value),
    )

    if (!isEmpty(newMasterEvent)) {
      this.setState({
        masterEvent: newMasterEvent,
      })
    }

    return newMasterEvent
  }

  isNotEmptyArray = data => Array.isArray(data) && data.length > 0

  getValueTypeByEventField = data => {
    const { eventInfo } = this.props
    let value = data

    if (eventInfo.type === TYPE_LIST) {
      value = String(value)
    }

    return value
  }

  findSlaveEvent = slaveEventId => {
    const {
      masterEvent: { slaves },
    } = this.state
    let slaveEvent = {}

    if (this.isNotEmptyArray(slaves)) {
      slaves.forEach(el => {
        const currentID = el.slave_id

        if (currentID === slaveEventId) {
          slaveEvent = el
        }
      })
    }

    return slaveEvent
  }

  render() {
    const { masterEvent } = this.state
    const {
      index,
      onEventValueChange,
      eventInfo,
      isEventOpen,
      updateValuesList,
      hideTitle,
      intl: { formatMessage },
    } = this.props
    const {
      slaves,
      activeForm,
      activeLocusGroup,
      activeLocus,
      type,
      values,
      value,
    } = eventInfo
    const showTitle =
      !hideTitle && type !== TYPE_INPUT_TEXTAREA && type !== TYPE_INPUT_FILE
    const hasSlaveEvents = this.isNotEmptyArray(slaves)
    const eventValue = this.isNotEmptyArray(values) ? masterEvent.value : ''

    return (
      <>
        <div className="lbf-event-item-box">
          {showTitle && (
            <div className="lbf-event-item-wrapper">
              <ListItemText
                primary={ifLogbookConstant(formatMessage)(eventInfo.title)}
              />
              {hasSlaveEvents && (
                <ArrowIcon className="lbf-event-item-box-arrow" />
              )}
            </div>
          )}
          <EventField
            index={index}
            eventInfo={{
              ...eventInfo,
              activeForm,
              activeLocusGroup,
              activeLocus,
              updateValuesList,
              value: hasSlaveEvents ? eventValue : value,
            }}
            onEventValueChange={
              hasSlaveEvents
                ? this.onMasterEventValueChange
                : onEventValueChange
            }
          />
        </div>
        {hasSlaveEvents && (
          <Collapse className="lbf-master-event-collapse" in={isEventOpen}>
            <div
              className="lbf-master-event-box"
              onClick={e => e.stopPropagation()}>
              {slaves.map(masterEventInfo => {
                const slaveEvent = this.findSlaveEvent(masterEventInfo.id)

                return (
                  <div
                    key={masterEventInfo.id}
                    className={cn('lbf-single-master-event', {
                      'lbf-event-boolean':
                        TYPE_INPUT_BOOLEAN === masterEventInfo.type,
                    })}>
                    <ListItemText
                      primary={ifLogbookConstant(formatMessage)(
                        masterEventInfo.title,
                      )}
                    />
                    <EventField
                      index={index}
                      disabled={!eventValue}
                      eventInfo={{
                        ...masterEventInfo,
                        activeForm,
                        activeLocusGroup,
                        activeLocus,
                        updateValuesList,
                        value: slaveEvent.value,
                      }}
                      onEventValueChange={data =>
                        this.onSlaveEventValueChange(data, slaveEvent)
                      }
                    />
                  </div>
                )
              })}
            </div>
          </Collapse>
        )}
      </>
    )
  }
}

export default injectIntl(MasterEventField)
